const map = {
	"./BaristaWorking.jpg": 5041,
	"./FrontPatio.jpg": 3650,
	"./IMG_2639_1.jpg": 974,
	"./IMG_2666.jpg": 8538,
	"./backPatio.jpg": 3444,
	"./backPatio2.jpg": 1060,
	"./food11_1.jpg": 8900,
	"./food12_1.jpg": 367,
	"./food13_1.jpg": 7002,
	"./food14_1.jpg": 3181,
	"./food15_1.jpg": 9128,
	"./frontGarden.jpg": 8174,
	"./fruit_1.jpg": 4382,
	"./happyStaff.jpg": 4206,
	"./mainSign.jpg": 8918,
	"./outdoor seating_1.jpg": 3661,
	"./pastry (3)_1.jpg": 7309,
	"./pastry (4)_1.jpg": 1752,
	"./pastry (5)_1.jpg": 3999,
	"./pastry (6)_1.jpg": 7586,
	"./pastry (7)_1.jpg": 4545,
	"./pastry (8)_1.jpg": 9100,
	"./storeFront.jpg": 9978
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3320;